export interface ParsedName {
    firstName: string;
    middleName: string;
    lastName: string;
}

export function parseNameString(nameString: string): ParsedName {
    const trimmedName = (nameString || '').trim();
    if (!trimmedName) {
        return { firstName: '', middleName: '', lastName: '' };
    }

    // "Last, First[, Middle...]" - the explicit comma format the extractor is asked to produce.
    if (trimmedName.includes(',')) {
        const parts = trimmedName.split(',').map(part => part.trim()).filter(Boolean);
        if (parts.length >= 2) {
            return {
                firstName: parts[1],
                middleName: parts.slice(2).join(' '),
                lastName: parts[0]
            };
        }

        // If the name does not have comma, we cannot extract first/middle/last name, procceed to split manually
        return splitOnSpaces(parts[0] || '');
    }

    // If the name does not have comma: Derive the last name from the final token so
    // the party still imports - previously the whole string went into firstName with an empty
    // lastName, which silently dropped the party on import to the matter.
    return splitOnSpaces(trimmedName);
}

function splitOnSpaces(name: string): ParsedName {
    const tokens = name.split(/\s+/).filter(Boolean);
    if (tokens.length === 0) {
        return { firstName: '', middleName: '', lastName: '' };
    }
    if (tokens.length === 1) {
        // A single token (mononym or company name) - keep it as the last name so it still imports.
        return { firstName: '', middleName: '', lastName: tokens[0] };
    }
    return {
        firstName: tokens[0],
        middleName: tokens.slice(1, -1).join(' '),
        lastName: tokens[tokens.length - 1]
    };
}
